<div class="card p-3" [ngClass]="error ? ['border-danger', 'border-1'] : []">
    <h3>{{ "Location" | translate }}</h3>
    <p>
        {{ "Address modal explanation" | translate }}
    </p>

    <!-- Location mode with search and map -->
    <ng-container *ngIf="useLocationModal">
        <div class="mb-3">
            <app-search-place (onResult)="setLocationResult($event)"></app-search-place>
        </div>

        <ng-container *ngIf="address">
            <div class="location-preview mb-3">
                <div class="location-info-card mb-3">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <i class="bi bi-geo-alt-fill text-primary me-2"></i>
                            <span>{{ getLocationSummary() }}</span>
                        </div>
                        <button type="button" class="btn btn-sm btn-link text-danger" (click)="clearLocation()">
                            <i class="bi bi-x-circle"></i>
                        </button>
                    </div>
                </div>
                <div class="map-container">
                    <div #mapElement class="location-map"></div>
                </div>
            </div>
        </ng-container>
    </ng-container>

    <!-- Regular address mode -->
    <ng-container *ngIf="!useLocationModal">
        <ng-container *ngIf="!address; else shippingAddressPanel">
            {{ "No address" | translate }}
        </ng-container>
        <ng-template #shippingAddressPanel>
            <app-address [address]="address"></app-address>
        </ng-template>
        <div class="text-right mt-auto">
            <button type="button" class="btn btn-outline-primary" (click)="selectAddress()">
                {{ "Select address" | translate }}
            </button>
        </div>
    </ng-container>

    <p class="text-muted small mt-3" [innerHTML]="'offer_location_hint' | translate"></p>

    <div class="form-group d-flex justify-content-end pt-4">
        <button type="button" class="btn btn-lg btn-primary d-inline-flex align-items-center" (click)="submit()">
            {{ "Next" | translate }} <span class="bi ps-2 bi-arrow-right"></span>
        </button>
    </div>
</div>
